import { DashboardConstants, documentationActions } from './constant';

const {
  GET_DASHBOARD_PATIENT_LIST_REQUEST,
  GET_DASHBOARD_ALL_SUBMITTED_DOCUMENT_REQUEST,
  GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_REQUEST,
  GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_RESET,
  GET_DASHBOARD_OVERVIEW_REQUEST,
  GET_DASHBOARD_DOCUMENTATION_REQUEST,
  GET_DASHBOARD_THERAPY_REQUEST,
  GET_DASHBOARD_TIME_IN_REQUEST,
  POST_DASHBOARD_CHECKOUT_REQUEST,
  POST_DASHBOARD_CHECKOUT_RESET,
  GET_DASHBOARD_TIME_IN_RESET,
  RESET_HARD_CLOCK_IN,
  GET_DASHBOARD_PATIENT_DETAILS_RESET,
  POST_DASHBOARD_CHECKOUT_RESET_LOGOUT,
  GET_DASHBOARD_PATIENT_DETAILS_REQUEST,
  POST_CHECKOUT_ACTION_RESET,
  GET_DASHBOARD_PTO_UPDATE_REQUEST,
  GET_INTERVENTION_GROUP_REQUEST,
  GET_GAME_BY_INTERVENTION_REQUEST,
  GET_AUTO_CLOCK_OUT_CALL_REQUEST,
  GET_DASHBOARD_ALL_SUBMITTED_DOCUMENT_RESET,
  REQUEST_SYNC_ALERTS_FROM_SIGNATURE,
  GET_THERAPIST_DAILY_UPDATES_REQUEST,
} = DashboardConstants;
const { DASHBOARD_SIGNATURE_TEMPLATE, DASHBOARD_DOC_PREVIEW } = documentationActions;

export const getTherapistDashboardPatientList = (payload: any) => {
  return {
    type: GET_DASHBOARD_PATIENT_LIST_REQUEST,
    payload,
  };
};

export const getAllTodaysDocumentAction = (payload: any) => {
  return {
    type: GET_DASHBOARD_ALL_SUBMITTED_DOCUMENT_REQUEST,
    payload,
  };
};
export const getAllTodaysDocumentCSVAction = (payload: any) => {
  return {
    type: GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_REQUEST,
    payload,
  };
};

export const getAllTodaysDocumentCSVRestAction = () => {
  return {
    type: GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_RESET,
  };
};

export const getAllTaskOverview = (payload: any) => {
  return {
    type: GET_DASHBOARD_OVERVIEW_REQUEST,
    payload,
  };
};
export const getAllTherapyOverview = (payload: any) => {
  return {
    type: GET_DASHBOARD_THERAPY_REQUEST,
    payload,
  };
};
export const getAllDocumentationOverview = (payload: any) => {
  return {
    type: GET_DASHBOARD_DOCUMENTATION_REQUEST,
    payload,
  };
};

//time check in out

export const getTimeCheckInAction = (payload: any) => {
  return {
    type: GET_DASHBOARD_TIME_IN_REQUEST,
    payload,
  };
};

export const postTimeCheckOutAction = (payload: any) => {
  return {
    type: POST_DASHBOARD_CHECKOUT_REQUEST,
    payload,
  };
};

export const postTimeCheckOutActionResetLogout = () => {
  return {
    type: POST_DASHBOARD_CHECKOUT_RESET_LOGOUT,
  };
};

//action reset

export const postCheckInOutActionReset = () => {
  return {
    type: POST_CHECKOUT_ACTION_RESET,
  };
};

export const postTimeCheckOutActionReset = () => {
  return {
    type: POST_DASHBOARD_CHECKOUT_RESET,
  };
};

export const getTimeCheckInActionReset = () => {
  return {
    type: GET_DASHBOARD_TIME_IN_RESET,
  };
};
export const resetHardClockIn = () => {
  return {
    type: RESET_HARD_CLOCK_IN,
  };
};

export const getDashboardPatientInfoAction = (payload: any) => {
  return {
    type: GET_DASHBOARD_PATIENT_DETAILS_REQUEST,
    payload,
  };
};

export const viewSignatureDashboardDoc = (payload: any) => {
  return {
    type: DASHBOARD_SIGNATURE_TEMPLATE,
    payload,
  };
};

export const previewDashboardDoc = (payload: any) => {
  return {
    type: DASHBOARD_DOC_PREVIEW,
    payload,
  };
};

export const getLatestPtoUpdates = (payload: any) => {
  return {
    type: GET_DASHBOARD_PTO_UPDATE_REQUEST,
    payload,
  };
};

//get intervention

export const getInterventionGroupAction = (payload: any) => {
  return {
    type: GET_INTERVENTION_GROUP_REQUEST,
    payload,
  };
};

//get games by intervention

export const getGamesByIntervention = (payload: any) => {
  return {
    type: GET_GAME_BY_INTERVENTION_REQUEST,
    payload,
  };
};

export const callAutoClockOutAction = (payload: any) => {
  return {
    type: GET_AUTO_CLOCK_OUT_CALL_REQUEST,
    payload,
  };
};

export const resetDashboardSubmittedDoc = () => {
  return {
    type: GET_DASHBOARD_ALL_SUBMITTED_DOCUMENT_RESET,
  };
};

export const requestSyncAlertsFromSignature = (payload: any) => {
  return {
    type: REQUEST_SYNC_ALERTS_FROM_SIGNATURE,
    payload,
  };
};

export const getTherapistDailyUpdatesAction = (payload: any) => {
  return {
    type: GET_THERAPIST_DAILY_UPDATES_REQUEST,
    payload,
  };
};
